// removed by extract-text-webpack-plugin
module.exports = {"data":"contact__data__1SPQ0","contact":"contact__contact__3u-ze","map":"contact__map__29aU-","address":"contact__address__1sHGT","openHours":"contact__openHours__11cgL","contact-header":"contact__contact-header__1ODJ7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Contact/contact.css
// module id = 34
// module chunks = 0